import type { FC } from 'react'
import styled from 'styled-components'

import Section from './Section'
import type { Filter as SectionFilterT } from './SectionFilter'
import SectionFilter, { DEFAULT_FILTER as DEFAULT_SECTION_FILTER } from './SectionFilter'

const Subtitle = styled.h4`
  margin-bottom: 5px;
`

export interface Filter {
  scottishWelsh: SectionFilterT
  other: SectionFilterT
}

export const DEFAULT_FILTER: Filter = {
  scottishWelsh: DEFAULT_SECTION_FILTER,
  other: DEFAULT_SECTION_FILTER,
}

interface Props {
  filter: Filter
  onChangeFilter: (sectionFilters: Filter) => void
}

const IdentitySectionFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <>
    <Section>
      <Subtitle>Scottish/ Welsh</Subtitle>
      <SectionFilter
        filter={filter.scottishWelsh}
        onChangeFilter={newFilter =>
          onChangeFilter({ ...filter, scottishWelsh: newFilter })
        }
      />
    </Section>
    <Section>
      <Subtitle>Other</Subtitle>
      <SectionFilter
        filter={filter.other}
        onChangeFilter={newFilter => onChangeFilter({ ...filter, other: newFilter })}
      />
    </Section>
  </>
)

export default IdentitySectionFilter
